<template>
  <b-container fluid>
    <b-row class="mb-3">
      <b-col md="6">
        <strong>Service</strong>
        <div>
          <b-badge variant="primary">{{ propChatbotPromptObj.prompt_service || 'N/A' }}</b-badge>
        </div>
      </b-col>

      <b-col md="6">
        <strong>Module</strong>
        <div>
          <b-badge variant="primary">{{ propChatbotPromptObj.prompt_module_name || 'N/A' }}</b-badge>
        </div>
      </b-col>
    </b-row>

    <!-- Macros -->
    <b-row class="mb-3">
      <b-col>
        <iq-card class="p-3">
          <template v-slot:body>
            <h6 class="mb-3">Prompt Macros</h6>
            <div v-if="propChatbotPromptObj.prompt_macro">
              <b-badge v-for="macro in macroList" :key="macro" variant="secondary" class="mr-2 mb-2">{{ macro }}</b-badge>
            </div>
            <div v-else class="text-muted">No Macros Found</div>
          </template>
        </iq-card>
      </b-col>
    </b-row>

    <!-- Prompt -->
    <b-row>
      <b-col>
        <iq-card class="p-3">
          <template v-slot:body>
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="mb-0">Prompt</h6>
            </div>
            <div v-if="propChatbotPromptObj.prompt" class="prompt-view-container">
              <pre class="prompt-content">{{propChatbotPromptObj.prompt}}</pre>
            </div>
            <div v-else class="text-center text-muted py-5">No Prompt Found</div>
          </template>
        </iq-card>
      </b-col>
    </b-row>

  </b-container>
</template>

<script>
import { socialvue } from "../../../config/pluginInit"
// import { ChatbotPromptApiObj } from "../../../FackApi/api/chatbotPrompt"
export default {
  name: "chatbotPromptView",
  components: {},
  props: {
    propChatbotPromptObj: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  mounted () {
    socialvue.index()
    // if (this.propChatbotPromptObj && this.propChatbotPromptObj.prompt_id) {
    //   this.chatbotPromptView(this.propChatbotPromptObj.prompt_id)
    // }
  },
  computed: {
    macroList () {
      if (!this.propChatbotPromptObj.prompt_macro) {
        return []
      }

      return this.propChatbotPromptObj.prompt_macro.split(",").map(item => item.trim()).filter(Boolean)
    }
  },
  data () {
    return {
      cvCardTitle: "View Chatbot Prompt",
      chatbotPromptObj: {}
    }
  },
  methods: {
    /**
     * chatbotPromptView
     */
    // async chatbotPromptView (promptIid) {
    //   try {
    //     let chatbotPromptViewResp = await ChatbotPromptApiObj.chatbotPromptView(this, promptIid)
    //     console.log("chatbotPromptViewResp:", chatbotPromptViewResp)
    //     if (chatbotPromptViewResp && !chatbotPromptViewResp.resp_status) {
    //       this.toastMsg = "Failed to fetch prompt details"
    //       this.toastVariant = "danger"
    //       this.showToast = true
    //       return false
    //     }
    //     this.chatbotPromptObj = chatbotPromptViewResp.resp_data.data
    //   }
    //   catch (err) {
    //     console.error("Exception occurred at chatbotPromptView() and Exception:", err.message)
    //   }
    //   finally {
    //     this.cvLoadingStatus = false
    //   }
    // }
  }
}
</script>
<style scoped>
.prompt-view-container {
  max-height: 500px;
  overflow-y: auto;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
}

.prompt-content {
  margin: 0;
  padding: 16px;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 14px;
  line-height: 1.6;
  font-family: Consolas, Monaco, monospace;
}
</style>
